import {
  getRouteProjectDetails,
  getRouteProjects,
  getRouteSignIn,
  getRouteSignUp,
  getRouteCreateProject,
  getRoutePrivacyNotice,
  getRouteTermsOfUse,
  getRouteEditProject,
  getRouteSettings,
  getRouteForgotPassword,
  getRouteResetPassword,
  AppRoutes,
  getRouteCookieNotice,
  getRouteVerifyOtp
} from "@/zapi-frontend/shared/const/router";

import { ProjectDetailsPage } from "@/zapi-frontend/pages/ProjectDetailsPage";
import { ProjectsPage } from "@/zapi-frontend/pages/ProjectsPage";
import { SignInPage } from "@/zapi-frontend/pages/SignInPage";
import { SignUpPage } from "@/zapi-frontend/pages/SignUpPage";
import { CreateProjectPage } from "@/zapi-frontend/pages/CreateProjectPage";
import { PrivacyNoticePage } from "@/zapi-frontend/pages/PrivacyNoticePage/PrivacyNoticePage";
import { TermsOfUsePage } from "@/zapi-frontend/pages/TermsOfUsePage/TermsOfUsePage";
import { UpdateProjectPage } from "@/zapi-frontend/pages/UpdateProjectPage";
import { SettingsPage } from "@/zapi-frontend/pages/SettingsPage";
import { NotFoundPage } from "@/zapi-frontend/pages/NotFoundPage/NotFoundPage";
import { ForgotPasswordPage } from "@/zapi-frontend/pages/ForgotPasswordPage";
import { ResetPasswordPage } from "@/zapi-frontend/pages/ResetPasswordPage";
import { VerifyOtpPage } from "@/zapi-frontend/pages/VerifyOtpPage";
import { RouteProps } from "react-router-dom";
import { CookieNoticePage } from "@/zapi-frontend/pages/CookieNoticePage/CookieNoticePage";
import { ERoleAccess, ERoleAccessType } from "@libs/shared-permissions";

type TRouteAccess = "protected" | "nonprotected" | "public";

export { ERoleAccess };
export type AppRoutesProps = RouteProps & {
  routePrivilege: TRouteAccess;
  roleAccess?: ERoleAccessType;
};

export const routeConfig: Record<AppRoutes, AppRoutesProps> = {
  [AppRoutes.NOT_FOUND]: {
    path: "*",
    element: <NotFoundPage />,
    routePrivilege: "public"
  },
  [AppRoutes.PROJECT_DETAILS]: {
    path: getRouteProjectDetails(":id"),
    element: <ProjectDetailsPage />,
    routePrivilege: "protected"
  },
  [AppRoutes.PROJECTS]: {
    path: getRouteProjects(),
    element: <ProjectsPage />,
    routePrivilege: "protected"
  },
  [AppRoutes.SIGN_IN]: {
    path: getRouteSignIn(),
    element: <SignInPage />,
    routePrivilege: "nonprotected"
  },
  [AppRoutes.SIGN_UP]: {
    path: getRouteSignUp(),
    element: <SignUpPage />,
    routePrivilege: "nonprotected"
  },
  [AppRoutes.CREATE_PROJECT]: {
    path: getRouteCreateProject(),
    element: <CreateProjectPage />,
    routePrivilege: "protected"
  },
  [AppRoutes.PRIVACY_NOTICE]: {
    path: getRoutePrivacyNotice(),
    element: <PrivacyNoticePage />,
    routePrivilege: "public"
  },
  [AppRoutes.TERMS_OF_USE]: {
    path: getRouteTermsOfUse(),
    element: <TermsOfUsePage />,
    routePrivilege: "public"
  },
  [AppRoutes.EDIT_PROJECT]: {
    path: getRouteEditProject(":id"),
    element: <UpdateProjectPage />,
    routePrivilege: "protected"
  },
  [AppRoutes.SETTINGS]: {
    path: getRouteSettings(),
    element: <SettingsPage />,
    routePrivilege: "protected"
    // roleAccess: ERoleAccess.CLIENT_ADMIN
  },
  [AppRoutes.FORGOT_PASSWORD]: {
    path: getRouteForgotPassword(),
    element: <ForgotPasswordPage />,
    routePrivilege: "public"
  },
  [AppRoutes.RESET_PASSWORD]: {
    path: getRouteResetPassword(),
    element: <ResetPasswordPage />,
    routePrivilege: "public"
  },
  [AppRoutes.COOKIE_NOTICE]: {
    path: getRouteCookieNotice(),
    element: <CookieNoticePage />,
    routePrivilege: "public"
  },
  [AppRoutes.VERIFY_OTP]: {
    path: getRouteVerifyOtp(),
    element: <VerifyOtpPage />,
    routePrivilege: "public"
  }
};
